import React from 'react'
import PropTypes from 'prop-types'
import BookingsList from 'components/shared/BookingsList'
import BookingsMap from 'components/shared/BookingsMap'

const TodaysBookings = ({mode, bookings}) => {
  if (bookings.edges.length === 0) {
    return (
      <div>Du har ingen bookinger i dag</div>
    )
  }

  if (mode === 'map') {
    return <BookingsMap bookings={bookings} />
  }

  return <BookingsList bookings={bookings} />
}

TodaysBookings.propTypes = {
  mode: PropTypes.string.isRequired,
  bookings: PropTypes.object.isRequired,
}

export default TodaysBookings
